module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-simple-analytics/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"eight-cu","short_name":"eight CU","start_url":"/","background_color":"#FFFFFF","theme_color":"#000099","display":"minimal-ui","icon":"static/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"a2b1422a2418f0f7aa2ee7eea59f2d89"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
